import React, { Fragment, useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText
} from '@mui/material';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import sendRequest from '../utils/sendRequest';
import { MenuButtonIcon, WarningButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function UnarchivePoDialog({ po_doc_id, poName, addSnackbar, fetchPos }) {
  const [open, setOpen] = useState(false);
  const [loadingUnarchive, setLoadingUnarchive] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingUnarchive) {
      setOpen(false);
    }
  };

  const unarchivePo = async () => {
    setLoadingUnarchive(true);
    try {
      let response = await sendRequest(`purchase-orders/unarchive-po?po_doc_id=${po_doc_id}`);
      fetchPos();
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingUnarchive(false);
      handleClose();
    }
  }

  return (
    <Fragment>
      <MenuButtonIcon
        color='warning'
        isIcon={true}
        title={"Unarchive PO"}
        text={""}
        icon={UnarchiveIcon}
        disabled={loadingUnarchive}
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingUnarchive}
      >
        <CustomDialogTitle
          header={"Unarchive PO"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Are you sure the PO should be removed from the archive?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingUnarchive}>Cancel</CancelButton>
          <WarningButton
            showSpinner={loadingUnarchive}
            text={"Unarchive PO"}
            onClick={() => unarchivePo()}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}